module.exports = __webpack_public_path__ + "static/media/bookmark_stocked.a6beec0a.svg";